import "metismenu"

$(function () {
    $("#side-menu").metisMenu()
})
